import { render, staticRenderFns } from "./pagesList.vue?vue&type=template&id=5547e253&scoped=true"
import script from "./pagesList.vue?vue&type=script&lang=js"
export * from "./pagesList.vue?vue&type=script&lang=js"
import style0 from "./pagesList.vue?vue&type=style&index=0&id=5547e253&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547e253",
  null
  
)

export default component.exports